import { CheckCircle2, Clock, AlertCircle, Truck, Hourglass, FileEdit, Activity, XCircle, Ban, RotateCcw } from "lucide-react";

const MAP = {
  paid: { text: "Payé", icon: CheckCircle2, cls: "bg-[#DCFCE7] text-[#15803D] border-[#bbf7d0]" },
  partial: { text: "Partiel", icon: Clock, cls: "bg-[#FEF3C7] text-[#B45309] border-[#fde68a]" },
  unpaid: { text: "Impayé", icon: AlertCircle, cls: "bg-[#FEE2E2] text-[#B91C1C] border-[#fecaca]" },
  delivered: { text: "Livré", icon: Truck, cls: "bg-[#DCFCE7] text-[#15803D] border-[#bbf7d0]" },
  pending: { text: "En attente", icon: Hourglass, cls: "bg-[#FEF3C7] text-[#B45309] border-[#fde68a]" },
  draft: { text: "Brouillon", icon: FileEdit, cls: "bg-[#F1F5F9] text-[#475569] border-[#e2e8f0]" },
  active: { text: "Actif", icon: Activity, cls: "bg-[#E0F2FE] text-[#0E7490] border-[#bae6fd]" },
  archived: { text: "Archivé", icon: Ban, cls: "bg-[#F1F5F9] text-[#475569] border-[#e2e8f0]" },
  voided: { text: "Annulé", icon: XCircle, cls: "bg-[#F1F5F9] text-[#475569] border-[#e2e8f0] line-through" },
  returned: { text: "Retourné", icon: RotateCcw, cls: "bg-[#F1F5F9] text-[#475569] border-[#e2e8f0]" },
  suspended: { text: "Suspendu", icon: Ban, cls: "bg-[#FEE2E2] text-[#B91C1C] border-[#fecaca]" },
  low: { text: "Stock faible", icon: AlertCircle, cls: "bg-[#FEF3C7] text-[#B45309] border-[#fde68a]" },
  out: { text: "En rupture", icon: XCircle, cls: "bg-[#FEE2E2] text-[#B91C1C] border-[#fecaca]" },
  ok: { text: "Disponible", icon: CheckCircle2, cls: "bg-[#DCFCE7] text-[#15803D] border-[#bbf7d0]" },
};

export default function StatusBadge({ status, label }) {
  const v = MAP[status] || MAP.draft;
  const Icon = v.icon;
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${v.cls}`}>
      <Icon className="w-3.5 h-3.5" />
      {label || v.text}
    </span>
  );
}
